import { z } from "zod";
import { FieldBaseSchema, defineControl } from "./field.js";
// On or off, like a check box, and with nowhere to show a placeholder. Required
// means it must be switched on, as a required check box must be ticked.
export const toggleSwitch = defineControl({
    key: "toggleSwitch",
    label: "Toggle switch",
    schema: FieldBaseSchema.extend({ control: z.literal("toggleSwitch") }),
    answer: z.boolean(),
    isClearable: false,
    empty: { required: false },
});
